import Icon from '../components/Icon.vue'

Icon.register({"chevron-left":{"width":1280,"height":1792,"paths":[{"d":"M1171 301l-531 531 531 531q19 19 19 45t-19 45l-166 166q-19 19-45 19t-45-19l-742-742q-19-19-19-45t19-45l742-742q19-19 45-19t45 19l166 166q19 19 19 45t-19 45z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/chevron-left.js
// module id = 634
// module chunks = 0